import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { setStatusBar, clearStatusBar } from './actions';

class StatusBar extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  render() {
    // Message and colour are required to render the status bar
    const { message, colour } = this.props;

    return (
      <div>
        { message && colour &&
          <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
            <div className={classNames('status-bar', colour)}>
              <div className="status-text">
                <p>{message}</p>
              </div>
              <div className="status-close">
                <img onClick={() => this.props.onClearStatusBar()} className="status_cross_icon" src="/icons/cross.svg" alt="Status close" />
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    message: state.statusBar.get('message'),
    colour: state.statusBar.get('colour'),
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onSetStatusBar: (message, colour) => dispatch(setStatusBar(message, colour)),
    onClearStatusBar: () => dispatch(clearStatusBar()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StatusBar);



/** WEBPACK FOOTER **
 ** ./src/containers/status-bar/index.js
 **/